// src/components/infografia/properties/QRCodeProperties.jsx
import React, { useState } from 'react';
import { FaQrcode } from 'react-icons/fa';
import QRSelectorModal from '../modals/QRSelectorModal';

const QRCodeProperties = ({ element, onUpdate, marcaId, marca }) => {
    // Asegurar que siempre tenemos propiedades válidas del elemento actual
    // No usar valores por defecto para la URL - solo mostrar lo que realmente tiene el elemento
    const props = element?.propiedades || {};

    const [showQRSelector, setShowQRSelector] = useState(false);

    const handleChange = (field, value) => {
        onUpdate({
            propiedades: {
                ...props,
                [field]: value
            }
        });
    };

    const handleSelectQR = (qrData) => {
        // Actualizar todas las propiedades de una vez
        onUpdate({
            propiedades: {
                ...props,
                url: qrData.url,
                qrName: qrData.name || props.qrName
            }
        });
    };

    return (
        <div className="space-y-4">
            {/* Seleccionar QR */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    QR Code
                </label>

                {props.url ? (
                    <div className="space-y-2">
                        {/* Mostrar QR seleccionado */}
                        <div className="p-3 bg-gray-50 border border-gray-200 rounded-md">
                            {props.qrName && (
                                <p className="text-sm font-medium text-gray-900 mb-1">
                                    {props.qrName}
                                </p>
                            )}
                            <p className="text-xs text-gray-500 truncate" title={props.url}>
                                {props.url}
                            </p>
                        </div>
                        <button
                            onClick={() => setShowQRSelector(true)}
                            className="w-full px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 flex items-center justify-center gap-2"
                        >
                            <FaQrcode />
                            Cambiar QR
                        </button>
                    </div>
                ) : (
                    <button
                        onClick={() => setShowQRSelector(true)}
                        className="w-full px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 flex items-center justify-center gap-2"
                    >
                        <FaQrcode />
                        Seleccionar QR
                    </button>
                )}
            </div>

            {/* QR Selector Modal */}
            {marcaId && (
                <QRSelectorModal
                    isOpen={showQRSelector}
                    onClose={() => setShowQRSelector(false)}
                    onSelectQR={handleSelectQR}
                    marcaId={marcaId}
                    marca={marca}
                />
            )}

            {/* Color */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Color de fondo */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color de Fondo
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.colorFondo || '#FFFFFF'}
                        onChange={(e) => handleChange('colorFondo', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.colorFondo || '#FFFFFF'}
                        onChange={(e) => handleChange('colorFondo', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Tamaño */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tamaño: {props.tamaño || 300}px
                </label>
                <input
                    type="range"
                    min="100"
                    max="1000"
                    value={props.tamaño || 300}
                    onChange={(e) => handleChange('tamaño', parseInt(e.target.value))}
                    className="w-full"
                />
            </div>
        </div>
    );
};

export default QRCodeProperties;

